var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-list',{attrs:{"tabs-enum":_vm.tabs,"title":_vm.title,"fixed-tabs":"","default-tab":_vm.defaultTab},on:{"change":_vm.changeTab},scopedSlots:_vm._u([{key:"tabItem",fn:function(ref){
var current = ref.current;
return [_c('users-list',{attrs:{"status":current}})]}}]),model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}})}
var staticRenderFns = []

export { render, staticRenderFns }